import { Pressable, View, Text } from "react-native";
import styles from "./Menus.styles";
import MaterialCommunityIcons from "react-native-vector-icons/MaterialCommunityIcons";
import { stdCouleurBleu, stdCouleurGrisClair } from "@commonStyle";
import { MenuWebProps } from "../Layout.types";

export default function MenuWeb({menuItems, isMenuDisabled, location, handleMenuItemPress}: MenuWebProps){
  return (
    <View style={styles.sidebar}>
      {menuItems.filter(item => !item.mobileOnly).map((item) => {
        const isItemDisabled = isMenuDisabled && item.path !== '/Collectivite';
        const isActive = location.pathname === item.path;

        return (
          <Pressable
            key={item.path}
            onPress={() => handleMenuItemPress(item.path)}
            style={[
              styles.menuItem,
              isActive && !isItemDisabled && styles.menuItemActive,
              isItemDisabled && styles.menuItemDisabled
            ]}
            disabled={isItemDisabled}
            testID={`BT_MENU_${item.label}`.replaceAll(/[' ]/g, '_').toUpperCase()}
          >
            <MaterialCommunityIcons
              name={item.icon}
              color={isItemDisabled ? stdCouleurGrisClair : stdCouleurBleu}
              size={20}
            />
            <Text style={[
              styles.menuItemText,
              isActive && !isItemDisabled && styles.menuItemTextActive,
              isItemDisabled && styles.menuItemTextDisabled
            ]}>
              {item.label}
            </Text>
          </Pressable>
        );
      })}
    </View>
  );
};
